import loadable from '@loadable/component';
export const Success=loadable(() => import('./Success'));
